module.exports = __webpack_public_path__ + "img/assessment_bg.e5cec5e2.jpeg";